import http from "@/request"


/**
 * 根据编码查询单位订阅列表
 * @param {*} code 
 * @returns 
 */
export function subscriptionListByUnitCode(code) {
    return http({
        url: "/baseService/subscription-list/" + code,
        method: "get"
    });
}

/**
 * 获取单位签约列表
 * @param {*} code 
 * @returns 
 */
export function signListByUnitCode(code) {
    return http({
        url: "/baseService/sign-list/" + code,
        method: "get"
    });
}

/**
 * 保存签约信息
 * @param {*} data 
 * @returns 
 */
export function saveSignInfo(data) {
    return http({
        url: "/baseService/saveInfo",
        method: "post",
        data
    });
}







// WEBPACK FOOTER //
// ./src/api/service.js